import * as cst from 'cornerstone-tools';

export default function invalidateAllTools(element: HTMLElement): void {
  cst.store.state.tools
    .filter((tool) => tool.element === element)
    .forEach((tool) => {
      cst.getToolState(element, tool.name)?.data?.forEach((measurementData: any) => {
        measurementData.invalidated = true;
        if (['Length', 'CircleRadius'].includes(tool.name)) {
          // For Length and CircleRadius, we also need to invalidate the cached length
          measurementData.length = undefined;
          measurementData.unit = undefined;
        }
      });
    });
}
